var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-back",on:{"click":function($event){return _vm.$emit('back')}}},[_c('FaIcon',{staticClass:"fa-rotate-270",attrs:{"icon":'chevron-up'}}),_c('span',[_vm._v(_vm._s(_vm.$t("company_system.back")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }